<template>
  <div class="section-settings">
    <ul class="section-settings__list">
      <li class="li setting-item" v-if="settings && settings.length" v-for="setting in settings">
        <p class="setting-item__title">{{ setting.title }}</p>
        <component
          class="setting-item__field"
          :field="setting" 
          :name="setting.key"
          :groupName="setting.label"
          :hint="setting.description"
          v-model="setting.value"
          :subFormData="setting.subForm"
          :is="basedOnMetafieldType(setting.type)"
          @input="onInput"
          >
        </component>
      </li>
      <li v-if="!settings || !settings.length">
        <h1 class="alert alert__title">You don’t have any settings yet</h1>
      </li>
    </ul>
  </div>
</template>

<script>
  import MetaFields from './metafields-edit/metafields'
  import { upperFirst, camelCase } from 'lodash'
  import { forMetafieldsContainer } from '@/mixins/metafields-changed-detection.mixin'
  export default {
    props: {
      settings: Array,
    },
    mixins: [ forMetafieldsContainer() ],

    components: {
      ...MetaFields
    },

    methods: {
      basedOnMetafieldType (type) {
        return 'MetafieldEdit' + upperFirst(camelCase(type))
      },
      onInput(val) {
        this.$emit('input', this.settings)
      }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';

  .section-settings {
    width: 668px;
    background-color: $color-white;
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);

    @include media(ltTablet) {
      width: 100%;
    }

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }

  .section-settings .new-field-button {
    border-right: none;
    border-bottom: none;
    border-left: none;
  }

  .section-settings__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px;

    li {
      width: 100%;
    }
    
    li.li {
      flex-shrink: 0;
      width: calc(100% - 10px);

      @include media(ltMobile) {
        width: 100%;
      }
    }



    .setting-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;


      &:hover {
        @include media(hover) {
          background-color: $color-athens-gray;

          .settings__icon {
            background-color: $color-geyser;
          }
        }
      }
      
      label {
        font-size: 14.6px;
        font-weight: 600;
        cursor: pointer;
      }

      &__icon {
        padding: 10px;
        background-color: $color-athens-gray;
        border-radius: 3px;

        svg {
          width: 20px;
          height: 20px;
          color: $color-regent-gray;
        }
      }
    }

    .alert {
      width: 100%;
      text-align: center;

      &__title {
        margin-top: 10px;
        color: $color-ebony-clay;
        font-size: 19px;
        font-weight: 500;
        line-height: 1.33;
      }

      &__subtitle {
        margin-top: 16px;
        margin-bottom: 10px;
        color: $color-pale-sky;
        font-size: 14.6px;
        line-height: 1.28;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/SectionSettings.vue